<div class="container">
    <div class="row justify-content-center">
        <div class="col-md-10">
            <div class="card spacing">
                <div class="card-title text-center">The best projects</div>
                <div class="card-text"><p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsa sit natus repudiandae quos sunt quo ullam est earum, nemo aliquid! Lorem ipsum dolor, sit amet consectetur adipisicing elit. Temporibus, quidem.</p></div>
            </div>
        </div>
    </div>

<div class="row">
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img small bottom2" src="../../../../assets/img/images2/image7.jpg" alt="Card image">
        </div>
    </div>
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img big bottom" src="../../../../assets/img/images2/image2.jpg" alt="Card image">
        </div>
    </div>
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img small bottom2" src="../../../../assets/img/images2/image6.jpg"alt="Card image">
        </div>
    </div>
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img small top bottom2" src="../../../../assets/img/images2/image4.jpg" alt="Card image">
        </div>
    </div>
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img small bottom2" src="../../../../assets/img/images2/image5.jpg" alt="Card image">
        </div>
    </div>
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img big top bottom" src="../../../../assets/img/images2/image3.jpg" alt="Card image">
        </div>
    </div>
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img big top bottom2" src="../../../../assets/img/images2/image1.jpg" alt="Card image">
        </div>
    </div>
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img small bottom2" src="../../../../assets/img/images2/image8.jpg" alt="Card image">
        </div>
    </div>
    <div class="col-sm-4 col-md-4 ">
        <div class="card">
            <img class="card-img small bottom2" src="../../../../assets/img/images2/image9.jpg" alt="Card image">
        </div>
    </div>
    
</div>
</div>
